import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import postsReducer from "../features/posts/postsSlice"
import projectsReducer from "../features/projects/projectsSlice"
import authReducer from "../features/auth/authSlice"
import skillsReducer from "../features/projects/skillsSlice"

export const store = configureStore({
  reducer: {
    posts: postsReducer,
    projects: projectsReducer,
    auth: authReducer,
    skills: skillsReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
